/*
Modo de uso:
                caller: IMPORTANTE! - REQUERIDO
                    Determinar quien lo llamó y además se usa para generar un nuevo id en sus elementos

            listSource: IMPORTANTE! - REQUERIDO
                    Fuente de datos

maxLengthToStartSearch: Por defecto 3 - OPCIONAL
                    Inidica la cantidad de caracteres antes de empezar con la validación

        propertyToFind: Por defecto un string vacio - REQUERIDO si automaticSearch es false
                    Nota: Importante, si automaticSearch este en false, se usa como criterio de busqueda

        propertyToShow: Por defecto un string vacio - OPCIONAL
                    Nota: Importante, si showDataList esta en true, se usa para mostrar en la lista la propiedad a modo descriptivo

       automaticSearch: Por defecto en false - OPCIONAL
                    Inidica si tiene que hacer una busqueda general en las propiedades del objeto, ejemplo:
                    listSource = [{a: 1, b: "bar"}, {a: 2, b: "foo"}]
                    automaticSearch = "true"
                    criterio busqueda = "1" o "b.."
                    resultado = [{a: 1, b: "bar"}]

          showDataList: Por defecto false - OPCIONAL
                    Inidica si tiene que mostrar la lista cuando el criterio de busqueda coinicide

            textToShow: Por defecto tiene la leyenda "No se encontró al usuario buscado" - OPCIONAL
                    Muestra el texto en caso de que la busqueda no sea exitosa

        onChangeHandle: Funcion - REQUERIDO
                    Funcion que se invoca en el padre/contenedor al producirse un cambio

Atributos HTML
    De la siguiente manera se puede especificar un grupo de atributos HTML en el control:
    Padre:
        let myprops = {className: "test", id: "miid"}
        <SearchInput {...myprops}/>
    Salida:
        <input class="test" id="miid"/>
 */

let React = require("react");

let SearchInput = React.createClass({
    propTypes: {
        caller: React.PropTypes.string,
        listSource: React.PropTypes.array,
        maxLengthToStartSearch: React.PropTypes.string,
        propertyToFind: React.PropTypes.string,
        propertyToShow: React.PropTypes.string,
        automaticSearch: React.PropTypes.string,
        showDataList: React.PropTypes.string,
        textToShow: React.PropTypes.string,
        onChangeHandle: React.PropTypes.func
    },

    getDefaultProps: function () {
        return {
            textToShow: "No se encontró al usuario buscado",
            listSource: [],
            maxLengthToStartSearch: "3",
            propertyToShow: "",
            propertyToFind: "",
            automaticSearch: "false",
            showDataList: "false"
        }
    },

    getInitialState: function () {
        return {
            userFound: false,
            showErrorMessage: false
        };
    },

    onChangeHandle: function (event) {
        const me = this.props;
        const evtValue = event.target.value.toLowerCase();
        let result = undefined;

        if (evtValue.length > Math.abs(this.props.maxLengthToStartSearch - 1)) {
            if (me.automaticSearch && me.automaticSearch == "true") {
                result = this.searchAll(evtValue);
            } else {
                result = this.props.listSource.filter(function (obj) {
                    let value = obj[me.propertyToFind].toString().toLowerCase();
                    return (value.indexOf(evtValue) >= 0 ? true : false);
                });
            }

            this.setState({ userFound: (result.length > 0) ? true : false, showErrorMessage: true });
        } else {
            this.setState({ userFound: false, showErrorMessage: false });
        }

        this.props.onChangeHandle(event);
    },

    searchAll: function (term) {
        return this.props.listSource.filter(function (obj) {
            return Object.keys(obj).some(function (key) {
                if (obj[key]) {
                    return obj[key].toString().toLowerCase().includes(term);
                } else {
                    return false;
                }
            });
        });
    },

    render: function () {
        let me = this.props;
        let dataOptions = null;
        let showErrorMessage = (this.state.userFound == false && this.state.showErrorMessage == true);
        showErrorMessage = showErrorMessage && me.value == "" ? !showErrorMessage : showErrorMessage
        let showDataList = (me.showDataList && me.showDataList == "true");

        if (showDataList) {
            dataOptions = me.listSource.map(function (value) {
                let newValue = value[me.propertyToShow];
                if (!newValue) {
                    console.error("propertyToShow: " + me.propertyToShow + " no es valida");
                }
                else {
                    return (<option id={newValue}>{newValue}</option>);
                }
            });
        }

        return (<div className="search">
            <span className="ti-search"></span>
            <input id={me.caller + "_txtBusqueda"}
                list={me.caller + "_list"}
                onChange={this.onChangeHandle}
                {...this.props} />
            {showErrorMessage && <span>{me.textToShow}</span>}
            {showDataList &&
                <datalist id={this.props.caller + "_list"}>
                    {dataOptions}
                </datalist>
            }
        </div >);
    }
});
export default SearchInput;